/** Кусок названия: подсвечен или нет. */
export interface Piece {
  text: string;
  hit: boolean;
}

/**
 * Нарезать название по отрезкам совпадений, которые прислал сервер.
 *
 * Индексы сервер считает в символах Python, клиент режет по UTF-16: для
 * кириллицы, латиницы и «°» это одно и то же. Кривые отрезки (пересечения,
 * выход за длину) не роняют строку — название важнее подсветки.
 */
export function splitHighlight(text: string, ranges?: [number, number][] | null): Piece[] {
  if (!ranges?.length) return [{ text, hit: false }];
  const pieces: Piece[] = [];
  let at = 0;
  for (const [rawStart, rawEnd] of [...ranges].sort((a, b) => a[0] - b[0])) {
    const start = Math.max(at, Math.min(rawStart, text.length));
    const end = Math.max(start, Math.min(rawEnd, text.length));
    if (start > at) pieces.push({ text: text.slice(at, start), hit: false });
    if (end > start) pieces.push({ text: text.slice(start, end), hit: true });
    at = Math.max(at, end);
  }
  if (at < text.length) pieces.push({ text: text.slice(at), hit: false });
  return pieces;
}
